import Vue from 'vue'
import { commons } from '@/utils'

Vue.use(commons)
